




































import { Component, Prop, Vue } from 'vue-property-decorator';
import Modal from 'frontend/components/Modal.vue';
import { Referral, ReferralDetails } from 'frontend/types/referral';
import { mapState } from 'vuex';
import { freeMonthsToDollarAmount } from 'frontend/utils/referral';
import { getJson } from 'frontend/utils/ajax';
import LoadingAnimation from 'frontend/components/LoadingAnimation.vue';

@Component({
  components: {
    LoadingAnimation,
    Modal,
  },
  computed: {
    ...mapState('referralDetails', ['referralDetailsData']),
  },
})
export default class ReferralHistoryModal extends Vue {
  @Prop() monthDollarAmount!: number;

  @Prop({ default: false }) legacyLoaded!: boolean;

  private referralDetailsData!: ReferralDetails;

  private legacyReferralDetailsData: ReferralDetails = {
    pending_referrals: [],
    past_referrals: [],
  };

  private legacyMonthDollarAmount: number = 0;

  private loading = false;

  private beforeMount() {
    if (this.legacyLoaded) {
      this.loading = true;
      // This vue component is used in django templates as well as in the usual vue workflow.
      // If we are loading it via the legacy framework we get the necessary data via the API
      // otherwise the data is available due to the vuex module.
      getJson('/referral/details/')
        .then(data => {
          if (data.response.success) {
            this.legacyReferralDetailsData = data.results.referral_details;
            this.legacyMonthDollarAmount = data.results.referrer_annual_plan_cost_per_month.cost;
          }
        })
        .catch(() => {
          // Since this is an aside piece of content and we can't access the store we ignore
          // errors in the legacy context.
        })
        .finally(() => {
          this.loading = false;
        });
    }
  }

  private bubbleClose(): void {
    this.$emit('close');
    this.$emit('external', { name: 'close' });
  }

  private get referrals(): ReferralDetails {
    return this.legacyLoaded ? this.legacyReferralDetailsData : this.referralDetailsData;
  }

  private get monthCost(): number {
    return this.legacyLoaded ? this.legacyMonthDollarAmount : this.monthDollarAmount;
  }

  private get pendingReferrals(): Referral[] {
    return this.referrals.pending_referrals;
  }

  private get pastReferrals(): Referral[] {
    return this.referrals.past_referrals;
  }

  private toDollarAmount(freeMonths: number): number {
    return freeMonthsToDollarAmount(freeMonths, this.monthCost);
  }
}
